module.exports = __webpack_public_path__ + "img/x6_Post.f4f19580.jpg";